/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'W'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAPW000001',
    EAPZ000003: 'EAPW000003',
    EAPZ000004: 'EAPW000004',
    EAPZ000018: 'EAPW000018',
    EAPZ000019: 'EAPW000019',
    EAPZ000020: 'EAPW000020',
    EAPZ000050: 'EAPW000050',
    EAPZ000051: 'EAPW000051',
    EBAZ000004: 'EBAW000004',
    EBAZ000005: 'EBAW000005',
    EBAZ000006: 'EBAW000006',
    EBAZ000007: 'EBAW000007',
    EBAZ000008: 'EBAW000008',
    EBAZ000009: 'EBAW000009',
    EBAZ000010: 'EBAW000010',
    EBAZ000011: 'EBAW000011',
    EBAZ000012: 'EBAW000012',
    EBAZ000013: 'EBAW000013',
    EBAZ000015: 'EBAW000015',
    EBAZ000104: 'EBAW000104',
    EBAZ000109: 'EBAW000109',
    EBAZ000111: 'EBAW000111',
    EBAZ000112: 'EBAW000112',
    EBAZ000113: 'EBAW000113',
    EBAZ000114: 'EBAW000114',
    EBAZ000115: 'EBAW000115',
    EBAZ000116: 'EBAW000116',
    EBAZ000117: 'EBAW000117',
    EBAZ000119: 'EBAW000119',
    EBAZ000120: 'EBAW000120',
    EBAZ000121: 'EBAW000121',
    EBAZ000122: 'EBAW000122',
    EBAZ000123: 'EBAW000123',
    EBAZ000124: 'EBAW000124',
    EBAZ000126: 'EBAW000126',
    EBAZ000127: 'EBAW000127',
    EBAZ000128: 'EBAW000128',
    EBAZ000293: 'EBAW000293',
    EBAZ000294: 'EBAW000294',
    EBAZ000319: 'EBAW000319',
    EBAZ000322: 'EBAW000322',
    EBAZ000349: 'EBAW000349',
    EBAZ000350: 'EBAW000350',
    EBAZ000351: 'EBAW000351',
    EBAZ000353: 'EBAW000353',
    EBAZ000355: 'EBAW000355',
    EBAZ000357: 'EBAW000357',
    EBAZ000358: 'EBAW000358',
    EBAZ000359: 'EBAW000359',
    EBAZ000363: 'EBAW000363',
    EBAZ000364: 'EBAW000364',
    EBAZ000379: 'EBAW000379',
    EBAZ000397: 'EBAW000397',
    EBAZ000398: 'EBAW000398',
    EBAZ000399: 'EBAW000399',
    EBAZ000496: 'EBAW000496',
    EBAZ000619: 'EBAW000619',
    EBAZ000644: 'EBAW000644',
    EBAZ000645: 'EBAW000645',
    EBAZ000647: 'EBAW000647',
    EBAZ000656: 'EBAW000656',
    EBAZ000721: 'EBAW000721',
    EBAZ000723: 'EBAW000723',
    EBAZ000731: 'EBAW000731',
    EBAZ000732: 'EBAW000732',
    EBAZ000733: 'EBAW000733',
    EBAZ000734: 'EBAW000734',
    EBAZ000774: 'EBAW000774',
    EBAZ000776: 'EBAW000776',
    EBAZ000781: 'EBAW000781',
    EBAZ000811: 'EBAW000811',
    EBAZ000812: 'EBAW000812',
    EBAZ000814: 'EBAW000814',
    EBAZ000816: 'EBAW000816',
    EBAZ000818: 'EBAW000818',
    EBAZ000819: 'EBAW000819',
    EBAZ000823: 'EBAW000823',
    EBAZ000892: 'EBAW000892',
    EBAZ000909: 'EBAW000909',
    EBAZ000999: 'EBAW000999',
    FDXZ000005: 'FDXW000005',
    FIFA000001: '',
  },
};

/**
 * ワーニングコードの定数定義
 */
export const WarningCodeConstants = {
  // ワーニングコード一覧(4桁目'W'とする)
  WARNING_CODES: {
    WBAZ000046: 'WBAW000046',
    WBAZ000047: 'WBAW000047',
    WBAZ000247: 'WBAW000247',
    WBAZ000252: 'WBAW000252',
    WBAZ000255: 'WBAW000255',
    WBAZ000570: 'WBAW000570',
    WBAZ000578: 'WBAW000578',
    WBAZ000579: 'WBAW000579',
    WBAZ000580: 'WBAW000580',
    WBAZ000581: 'WBAW000581',
    WBAZ000582: 'WBAW000582',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'IBX',
  TWO_LETTER: 'FW',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'TYOFW08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'TYOFW08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'TYOFW08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: '' as '' | 'alphaNumberic' | 'numberic',
    length: 0,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 0,
    maxPwLength: 0,
    pwRegex: '.*',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: false,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: false,
  LOGO_FILE_PATH: 'assets/images/logo_ibx.svg',
  LOGO_S_FILE_PATH: 'assets/images/logo_ibx_s.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_ibx_biz.svg',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {} as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  IMG: {
    // 全体
    ALL_EXTERNAL_PRIMARY: 'assets/images/icon_external_ibx_navy_16.svg',
    ALL_EXTERNAL_RED: 'assets/images/icon_external_ibx_red_16.svg',
    ALL_HELP_PRIMARY: 'assets/images/icon_help_ibx_navy_24.svg',
    SUB_HEADER_HELP_WHITE: 'assets/images/icon_help_ibx_white_navy_24.svg',
    ALL_CHECKINSTATUS_NOTACCEPTED: 'assets/images/icon_remove_ibx_navy_20.svg',
    ALL_CHECKINSTATUS_ACCEPTED: 'assets/images/icon_feature_available_ibx_navy_24.svg',
    LOGO_20_FILE_PATH: 'assets/images/logo_star_alliance_20.svg',

    // C01-P040-S01-U チェックインシートマップ
    C01_P040_S01_U_SEATMAP_FLOAT_LEGEND: 'assets/images/seatmap_float_legend_ibx.svg',
    C01_P040_S01_U_SEATMAP_FLOAT_SEATTYPE: 'assets/images/seatmap_float_seattype_ibx.svg',
    C01_P040_S01_U_LEGENDS_SEAT_SELECTED: 'assets/images/seat_selected_ibx_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_BEFORE_CHANGE_FREE_SEAT: 'assets/images/seat_before_change_free_seat_ibx_24.svg',
    C01_P040_S01_U_LEGENDS_EMERGENCY_EXIT_SEAT: 'assets/images/seat_emergency_exit_seat_ibx_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_LAVATORY: 'assets/images/seat_lavatory_ibx_24.svg',
    C01_P040_S01_U_LEGENDS_GALLEY: 'assets/images/seat_galley_ibx_24.svg',
    C01_P040_S01_U_LEGENDS_WING: 'assets/images/seat_wing_ibx_24.svg',
  },
  ABLE_D_TRANSITION_PARAMETER: {
    EXTERNAL_FLG: 'NEWIBX',
    ALLIANCE_FLG: 'IBX',
  },
} as const;
